// @flow

export default [
  {
    id: 297,
    name: "QUICK_LINKS",
    description: "",
    subtitle: ""
  },
  {
    id: 298,
    name: "PROMO_BANNER_TOP",
    description: "",
    subtitle: ""
  },
  {
    id: 299,
    name: "UPCOMING_RACES",
    description: "",
    subtitle: ""
  },
  {
    id: 300,
    name: "TOP_RACES",
    description: "Today's Popular Races",
    subtitle: ""
  },
  {
    id: 302,
    name: "TOP_TRACKS",
    description: "Top Tracks",
    subtitle: ""
  },
  {
    id: 476,
    name: "PROMO_BANNER_BOTTOM",
    description: "",
    subtitle: ""
  }
];
